export const actions = {
  setIntentionType: (data) => {
    return {
      type: "SET_INTENTIONTYPE",
      payLoad: data,
    };
  },
  setIsIntention: (data) => {
    return {
      type: "SET_ISINTENTION",
      payLoad: data,
    };
  },

  setintentionNo: (data) => {
    return {
      type: "SET_INTENTIONO",
      payLoad: data,
    };
  },
};

const initState = {
  isIntention:false,
  setintentionNo:null
};

const carInfoReducer = (state = initState, actions) => {
  const { type, payLoad } = actions;
  switch (type) {
    case "SET_INTENTIONTYPE":
      return {
        ...state,
        intentionType: payLoad,
      };
    case 'SET_ISINTENTION':
      return {
        ...state,
        isIntention: payLoad,
      }
    case 'SET_INTENTIONO':
      return {
        ...state,
        intentionNo: payLoad,
      }
    default:
      return {
        ...state,
      };
  }
};
export default carInfoReducer;
